import { getRegisterZReportHistory, getZReportHistory } from '../../api/admin';
import { compareRegisterActivationDates, timestampToDate } from '../../utils/date';
import invalidationManager from './InvalidationManager';

export interface ZReportSummary {
  id: string;
  time: Date | null;
}

export const { hook: useZHistory, fetcher: zHistoryStore } = invalidationManager.createFetcher({
  queryKey: (companyId: string) => ['company', companyId, 'z-history'],
  fetchFunction: async (companyId: string): Promise<ZReportSummary[]> => {
    if (!companyId) {
      return [];
    }
    const response = await getZReportHistory(companyId);
    return response.reports.map((report) => ({
      id: report.id,
      time: timestampToDate(report.time),
    }));
  },
});

export const { hook: useRegisterZHistory, fetcher: registerZHistoryStore } =
  invalidationManager.createFetcher({
    queryKey: (companyId: string) => ['company', companyId, 'z-history', 'registers'],
    fetchFunction: async (companyId: string) => {
      if (!companyId) {
        return [];
      }
      const response = await getRegisterZReportHistory(companyId);
      return [...response.registers].sort(compareRegisterActivationDates).map((register) => ({
        ...register,
        reports: register.reports.map((report) => ({
          id: report.id,
          time: timestampToDate(report.time),
        })),
      }));
    },
  });
